import URL from 'url-parse'
import {isURL} from 'validator'
import blacklist from './blacklist'
import {isPlainObject} from 'lodash'
import CryptoJS from 'crypto-js'
import {getCookie} from '../../static/js/mixins'

export const LIMIT_LINKS_DISPLAY = 5
const TEST_HOSTNAMES = ['127.0.0.1', 'localhost', 'free-url-shortener.test.rb.gy']
export const QR_CODE_COOKIE_NAME = 'qr-data-v2'
export const SHORTENER_COOKIE_NAME = 'links-data-external-v2'

export const isTestEnv = () => {
  if (typeof location === 'undefined') return null
  return (
    TEST_HOSTNAMES.some((host) => host === location.hostname)
  )
}

export function copyToClipboard (shortUrl, referral) {
  if (!navigator.clipboard && referral){
    referral.select()
    referral.setSelectionRange(0, 99999)
    document.execCommand('copy')
    return Promise.resolve()
  } else {
    return navigator.clipboard.writeText(shortUrl)
  }
}

export function validateCookieLink (entry = {}) {
  if (!isPlainObject(entry)) return false

  const HOSTNAME = isTestEnv() ? 'test.rb.gy' : 'rb.gy'
  let { destination, shortUrl } = entry
  let { hostname } = new URL(destination, {}, true)
  let { hostname: brandedHostname } = new URL(shortUrl, {}, true)

  let isValidURL = isURL(destination, { allow_underscores: true }) && !blacklist.some((_host) => _host === hostname)
  let isValidShortURL = isURL(shortUrl, { allow_underscores: true }) && brandedHostname === HOSTNAME

  return !!entry.id && isValidURL && isValidShortURL
}

export const encryptWithSHA256 = (text) => {
  let hash = CryptoJS.SHA256(text)
  return hash.toString(CryptoJS.enc.Base64)
}

export const encryptWithAES = (text) => {
  const passphrase = process.env.REACT_APP_ENCRYPTION_SECRET
  return CryptoJS.AES.encrypt(text, passphrase).toString()
}

export const decryptWithAES = (ciphertext) => {
  const passphrase = process.env.REACT_APP_ENCRYPTION_SECRET
  const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase)
  return  bytes.toString(CryptoJS.enc.Utf8)
}

export const getLinksFromCookie = (isQr) => {
  const cookieName = isQr ? encryptWithSHA256(QR_CODE_COOKIE_NAME) : encryptWithSHA256(SHORTENER_COOKIE_NAME)
  let cookieData
  try {
    cookieData = JSON.parse(getCookie(cookieName) || '{}')
  } catch (e) {
    cookieData = null
  }
  return (cookieData?.id && validateCookieLink(cookieData)) ? [cookieData] : []
}
